import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface ConflictResolutionModalProps {
  isOpen: boolean;
  assignmentId: string;
  field: string;
  userValue: any;
  serverValue: any;
  currentData: any;
  onAcceptServer: () => void;
  onOverwrite: () => void;
  onCancel: () => void;
}

const ConflictResolutionModal: React.FC<ConflictResolutionModalProps> = ({
  isOpen,
  assignmentId,
  field,
  userValue,
  serverValue,
  currentData,
  onAcceptServer,
  onOverwrite,
  onCancel
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const getFieldLabel = (fieldName: string) => {
    switch (fieldName) {
      case 'artistId':
        return 'Художник';
      case 'estimatedHours':
        return 'Часы';
      case 'hourlyRate':
        return 'Ставка';
      default:
        return fieldName;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold text-white mb-4">
          {t('conflict.title') || 'Конфликт версий'}
        </h2>
        
        <p className="text-gray-300 mb-4">
          {t('conflict.description') || 'Данные были изменены другим пользователем. Выберите действие:'}
        </p>

        <div className="bg-gray-700 rounded p-4 mb-4">
          <div className="mb-3">
            <div className="text-sm text-gray-400 mb-1">{t('conflict.field') || 'Поле'}:</div>
            <div className="text-white font-medium">{getFieldLabel(field)}</div>
          </div>
          
          <div className="mb-3">
            <div className="text-sm text-gray-400 mb-1">{t('conflict.yourValue') || 'Ваше значение'}:</div>
            <div className="text-blue-300">{String(userValue)}</div>
          </div>
          
          <div className="mb-3">
            <div className="text-sm text-gray-400 mb-1">{t('conflict.serverValue') || 'Текущее значение на сервере'}:</div>
            <div className="text-green-300">{String(serverValue)}</div>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onAcceptServer}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded transition-colors"
          >
            {t('conflict.acceptServer') || 'Принять серверные изменения'}
          </button>
          
          <button
            onClick={onOverwrite}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
          >
            {t('conflict.overwrite') || 'Перезаписать'}
          </button>
          
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded transition-colors"
          >
            {t('conflict.cancel') || 'Отмена'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConflictResolutionModal;

